export default __webpack_public_path__ + "static/media/unhappy.80887c1e.svg";